module.exports = __webpack_public_path__ + "img/check-blue.a425b3dd.svg";